import VerifyEmailComponent from "../components/auth/VerifyEmailComponent";

export const VerifyEmailPage = () => {
    return ( 
        <div >
            <VerifyEmailComponent />
        </div>
     );
};

export default VerifyEmailPage
